import styled from 'styled-components';

// 컨텐츠 감싸는 컴포넌트
export const ContentWrap = styled.div`
	margin-top: 26px;
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;  /* 중앙 정렬 */
	align-items: center;  /* 가로 중앙 정렬 */
`;
